import { makeRequest } from 'utils/requestLogger';

export default (id, studentID, dateStart, dateEnd) =>
  makeRequest(
    'get',
    `/api/courses/${id}/get_online_roundtable_engagement/${studentID}?dateStart=${dateStart}&dateEnd=${dateEnd}`
  ).then((res) => res.data);


// WEBPACK FOOTER //
// ./src/app/services/courses/getOnlineRoundtableEngagement.js